import { convert } from "../convert.js";
import { state, conversionProfile, setProfileId } from "../state.js";
import { el, actionButton, announce, setBusy } from "../ui/dom.js";
import { profileSelect } from "../ui/profile-select.js";
import { docxDropzone, readDocx } from "../ui/dropzone.js";

export const CONVERT_ERROR = "Couldn't convert that file. It may be corrupted, password-protected, or not a valid .docx.";

export function mount(root, route, nav) {
  let pending = state.doc; // chosen file, kept only once it converts
  const error = el("p", { class: "fire-message", role: "alert", hidden: true });
  const chosen = el("p", { class: "chosen", hidden: true });
  const convertButton = el("button", { type: "button", class: "primary-btn big", disabled: true }, "Convert to HTML");
  const { dropzone, input } = docxDropzone({ id: "drop", title: "Drop your Word document here", onFile: accept });
  const { wrapper: profileField } = profileSelect({
    id: "style-with", label: "Style with", value: conversionProfile().id, onChange: (id) => setProfileId(id),
  });

  const showError = (message) => {
    error.textContent = message;
    error.hidden = !message;
  };

  function render() {
    chosen.hidden = !pending;
    chosen.replaceChildren(...(pending
      ? [
        el("span", {}, "Chosen: ", el("strong", {}, pending.name)),
        actionButton("Remove", pending.name, {
          class: "link-btn",
          onclick: () => {
            pending = null;
            state.doc = null;
            state.result = null;
            render();
            dropzone.focus();
          },
        }),
      ]
      : []));
    convertButton.disabled = !pending;
  }

  async function accept(file) {
    showError("");
    const { doc, error: problem } = await readDocx(file);
    if (problem) return showError(problem);
    pending = doc;
    render();
    announce(`${file.name} chosen. Press Convert to HTML.`);
  }

  convertButton.addEventListener("click", async () => {
    if (!pending) return;
    showError("");
    setBusy(convertButton, true, "Converting…");
    try {
      const profile = conversionProfile();
      const { html, messages } = await convert(pending.data, profile);
      state.doc = pending;
      state.result = { html, messages, profileJson: JSON.stringify(profile) };
      nav.go("#/result");
    } catch (err) {
      console.error(err);
      setBusy(convertButton, false);
      showError(CONVERT_ERROR);
    }
  });

  root.append(el("section", { class: "convert" },
    el("h1", {}, "Convert a Word document to HTML"),
    dropzone, input, chosen, error, profileField, convertButton,
    el("p", { class: "secondary-link" }, el("a", { href: "#/profiles" }, "Create or edit a profile")),
    el("p", { class: "secondary-link demo-link" }, "New here? ", el("a", { href: "#/demo" }, "Try a demo"), ": edit a sample Word document and turn it into Bootstrap HTML.")));
  render();
  return { title: "Convert" };
}
